import React from 'react';

class CodigoDePracticasComerciales_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Código de Prácticas Comerciales';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_CODIGO_PRACTICAS_COMERCIALES_2024_V1.pdf?alt=media&token=b08034a2-908b-4fe4-b8c1-ec8904d82f8b';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default CodigoDePracticasComerciales_pdf